export enum MediaSource {
  ONBOARDING = "ONBOARDING",
  YZ = "YZ",
  NON_YZ = "NON_YZ",
  UNKNOWN = "UNKNOWN",
  MESSAGES = "MESSAGES",
}
